import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  _theme => ({
    backArrow: {
      color: "#247CFF",
      cursor: "pointer",
      fontSize: 25,
      marginRight: "10px"
    },
    codeText: {
      fontSize: 24
    },
    codeTextContainer: {
      alignItems: "center",
      display: "flex"
    },
    container: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      margin: "10px 0"
    },

    generatedFieldsText: {
      color: "#747C8C",
      fontSize: 24
    }
  }),
  { name: "UnlockCodesHeader" }
);

export default useStyles;
